export const translation: {
  [id: string]: {
    De: string;
    En: string;
    Us: string;
  };
} = {
  hello: {
    De: 'hallo',
    En: 'hello',
    Us: 'hello',
  },
  international: {
    De: 'International',
    En: 'German',
    Us: 'German',
  },
  contact: {
    De: 'Kontaktieren Sie uns',
    En: 'Contact us',
    Us: 'Contact us',
  },
  menu: {
    De: 'Menü',
    En: 'Menu',
    Us: 'Menu',
  },
  question: {
    De: 'Fragen?',
    En: 'Questions?',
    Us: 'Questions?',
  },
  clock: {
    De: 'Uhr',
    En: 'Clock',
    Us: 'Clock',
  },
  cookie: {
    De: 'Cookie-Einstellungen',
    En: 'Cookie Settings',
    Us: 'Cookie Settings',
  },
  closeBanner: {
    De: 'Banner schließen',
    En: 'Close banner',
    Us: 'Close banner',
  },
  catalogTitle: {
    De: 'Unseren Katalog bestellen',
    En: 'Order our catalogue',
    Us: 'Order our catalogue',
  },
  catalogDescription: {
    De:
      'Erhalten Sie unseren Gesamtkatalog mit vielen Inspirationen kostenfrei per Post oder auch per E-Mail zugeschickt.',
    En:
      'Receive our complete catalogue, with lots of inspiration, free of charge by post or email.',
    Us:
      'Receive our complete catalogue, with lots of inspiration, free of charge by post or email.',
  },
  printCatalogTitle: {
    De: 'Print Katalog',
    En: 'Print Catalogue',
    Us: 'Print Catalogue',
  },
  digitalCatalogTitle: {
    De: 'Digitaler Katalog',
    En: 'Digital Catalogue',
    Us: 'Digital Catalogue',
  },
  catalogMobilePanelTitle: {
    De: 'Katalog jetzt anfordern',
    En: 'Request catalog now',
    Us: 'Request catalog now',
  },
  deliveryDates: {
    De: 'liefertermine',
    En: 'Delivery Dates',
    Us: 'Delivery Dates',
  },
  wood: {
    De: 'holz',
    En: 'wood',
    Us: 'wood',
  },
  aluminum: {
    De: 'alu',
    En: 'aluminum',
    Us: 'aluminum',
  },
  fireresistance: {
    De: 'Brandschutzfenster',
    En: 'fireresistant window',
    Us: 'fireresistant window',
  },
  requiredFieldsReminder: {
    De: 'Pflichtfelder bitte ausfüllen',
    En: 'Please fill out mandatory fields',
    Us: 'Please fill out mandatory fields',
  },
  salutation: {
    De: 'Anrede',
    En: 'Salutation',
    Us: 'Salutation',
  },
  emailAddress: {
    De: 'E-Mail-Adresse',
    En: 'E-Mail-Address',
    Us: 'E-Mail-Address',
  },
  woman: {
    De: 'Frau',
    En: 'Ms.',
    Us: 'Ms.',
  },
  man: {
    De: 'Herr',
    En: 'Mr.',
    Us: 'Mr.',
  },
  firstname: {
    De: 'Vorname',
    En: 'First name',
    Us: 'First name',
  },
  lastname: {
    De: 'Nachname',
    En: 'Last name',
    Us: 'Last name',
  },
  company: {
    De: 'Unternehmen',
    En: 'Company',
    Us: 'Company',
  },
  postCode: {
    De: 'PLZ',
    En: 'PostCode',
    Us: 'PostCode',
  },
  phone: {
    De: 'Telefon',
    En: 'Phone',
    Us: 'Phone',
  },
  street: {
    De: 'Straße',
    En: 'Street',
    Us: 'Street',
  },
  houseNumber: {
    De: 'Hausnummer',
    En: 'House number',
    Us: 'House number',
  },
  location: {
    De: 'Ort',
    En: 'Location',
    Us: 'Location',
  },
  comment: {
    De: 'Kommentar',
    En: 'Comment',
    Us: 'Comment',
  },
  numberMessage: {
    De: 'Bitte nur Nummern eingeben!',
    En: 'Please only enter numbers!',
    Us: 'Please only enter numbers!',
  },
  companyMessage: {
    De: 'Bitte geben Sie Ihren Unternehmen ein!',
    En: 'Please enter your company!',
    Us: 'Please enter your company!',
  },
  genderMessage: {
    De: 'Bitte wählen Sie Ihre Anrede!',
    En: 'Please select your salutation!',
    Us: 'Please select your salutation!',
  },
  firstNameMessage: {
    De: 'Bitte geben Sie Ihren Vornamen ein!',
    En: 'Please enter your first name!',
    Us: 'Please enter your first name!',
  },
  lastNameMessage: {
    De: 'Bitte geben Sie Ihren Nachnamen ein!',
    En: 'Please enter your address!',
    Us: 'Please enter your address!',
  },
  streetMessage: {
    De: 'Bitte geben Sie Ihre Adresse ein!',
    En: 'Please enter your address!',
    Us: 'Please enter your address!',
  },
  houseNumberMessage: {
    De: 'Bitte geben Sie Ihre Hausnummer ein!',
    En: 'Please enter your house number!',
    Us: 'Please enter your house number!',
  },
  postCodeMessage: {
    De: 'Bitte geben Sie Ihre PLZ ein!',
    En: 'Please enter your postcode!',
    Us: 'Please enter your postcode!',
  },
  postCodeMessage1: {
    De: 'Bitte geben Sie Ihre Postleitzahl ein!',
    En: 'Please enter your zip code!',
    Us: 'Please enter your zip code!',
  },
  locationMessage: {
    De: 'Bitte geben Sie Ihre Ort ein!',
    En: 'Please enter your location!',
    Us: 'Please enter your location!',
  },
  emptyEmailMessage: {
    De: 'Bitte geben Sie Ihre E-Mail Adresse ein!',
    En: 'Please enter your e-mail address!',
    Us: 'Please enter your e-mail address!',
  },
  validEmailMessage: {
    De: 'Bitte geben Sie eine gültige E-Mail Adresse ein',
    En: 'Please enter a valid email address',
    Us: 'Please enter a valid email address',
  },
  privacyPolicyMessage: {
    De:
      'Bitte überprüfen Sie die Datenschutzerklärung und stimmen Sie der Datenverarbeitung zu!',
    En: 'Please check the privacy policy and agree to the data processing!',
    Us: 'Please check the privacy policy and agree to the data processing!',
  },
  acceptPrivarcyPolicyMsg1: {
    De: 'Ich habe die',
    En: 'I have the',
    Us: 'I have the',
  },
  acceptPrivarcyPolicyMsg2: {
    De: 'Datenschutzerklärung',
    En: 'Data protection',
    Us: 'Data protection',
  },
  acceptPrivarcyPolicyMsg3: {
    De: 'gelesen und willige in die Datenverarbeitung ein.',
    En: 'read and agree to the data processing.',
    Us: 'read and agree to the data processing.',
  },
  requestCatalog: {
    De: 'Katalog anfordern',
    En: 'Request catalogue',
    Us: 'Request catalogue',
  },
  errorMessage: {
    De: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
    En: 'There has been an error. Please try again later',
    Us: 'There has been an error. Please try again later',
  },
  printSuccessMessage: {
    De:
      ' Vielen Dank für Ihr Interesse. Sie erhalten Ihren Katalog schnellstmöglich per Post von uns.',
    En:
      'Thanks for your interest. You will receive your catalog from us by post as soon as possible.',
    Us:
      'Thanks for your interest. You will receive your catalog from us by post as soon as possible.',
  },
  digitalMessage: {
    De:
      'Vielen Dank für Ihr Interesse. Sie erhalten in Kürze eine E-Mail mit dem Downloadlink zu Ihrem Katalog.',
    En:
      'Thanks for your interest. You will shortly receive an email with the download link to your catalogue.',
    Us:
      'Thanks for your interest. You will shortly receive an email with the download link to your catalogue.',
  },
  pageNotFoundMessage: {
    De: 'ups! 404(seite)',
    En: 'oops! 404(page)',
    Us: 'oops! 404(page)',
  },
  pageNotFoundMessage1: {
    De: 'nicht gefunden',
    En: 'not found',
    Us: 'not found',
  },
  goToHome: {
    De: 'Zurück zur Startseite',
    En: 'Back to home page',
    Us: 'Back to home page',
  },
  from: {
    De: 'von',
    En: 'from',
    Us: 'from',
  },
  all: {
    De: 'Alle',
    En: 'All',
    Us: 'All',
  },

  sendRequest: {
    De: 'Anfrage verschicken',
    En: 'Send Request',
    Us: 'Send Request',
  },
  environment: {
    De: 'Umgebung',
    En: 'Environment',
    Us: 'Environment',
  },
  loginTitle: {
    De: 'LOGIN',
    En: 'LOGIN',
    Us: 'LOGIN',
  },
  configurator: {
    De: 'FENSTERKONFIGURATOR',
    En: 'WINDOW CONFIGURATOR',
    Us: 'WINDOW CONFIGURATOR',
  },
  validPasswordMessage: {
    De: 'Bitte geben Sie ein Passwort ein',
    En: 'Please enter a password',
    Us: 'Please enter a password',
  },
  validPinMessage: {
    De: 'Bitte geben Sie eine gültige PIN ein',
    En: 'Please enter a valid PIN',
    Us: 'Please enter a valid PIN',
  },
  login: {
    De: 'Login',
    En: 'Login',
    Us: 'Login',
  },
  register: {
    De: 'Registrieren',
    En: 'Register',
    Us: 'Register',
  },
  emailAdress: {
    De: 'E-Mail Adresse',
    En: 'Email address',
    Us: 'Email address',
  },
  password: {
    De: 'Passwort',
    En: 'Password',
    Us: 'Password',
  },
  newPassword: {
    De: 'Neue Passwort',
    En: 'New Password',
    Us: 'New Password',
  },
  newRegistration: {
    De: 'Neu hier? Registrieren Sie sich als Kunde',
    En: 'New here? Register as a customer',
    Us: 'New here? Register as a customer',
  },
  forgotPasswordReset: {
    De: 'Passwort zurücksetzen',
    En: 'Reset my password?',
    Us: 'Reset my password?',
  },
  forgotPassword: {
    De: 'Passwort vergessen?',
    En: 'Forgot Password?',
    Us: 'Forgot Password?',
  },
  loginError: {
    De: 'E-Mail Adresse oder Passwort ist falsch',
    En: 'Email address or password is incorrect',
    Us: 'Email address or password is incorrect',
  },
  invalidLoginRequest: {
    De: 'Ungültige Anmeldeanfrage',
    En: 'Login failed. Please check your credentials and try again.',
    Us: 'Login failed. Please check your credentials and try again.',
  },
  invalidRegisterRequest: {
    De: 'Ungültige Registrierungsanfrage',
    En: 'Registration failed. Please check your data and try again.',
    Us: 'Registration failed. Please check your data and try again.',
  },
  databaseError: {
    De: 'Fehler an der Datenbank',
    En: 'Database error',
    Us: 'Database error',
  },
  invalidCredentials: {
    De: 'Ungültige Anmeldeinformationen',
    En: 'Invalid login credentials',
    Us: 'Invalid login credentials',
  },
  invalidEmailOrPassword: {
    De: 'Ungültige E-Mail-Adresse oder Passwort',
    En: 'Invalid email address or password',
    Us: 'Invalid email address or password',
  },
  empty: {
    De: '',
    En: '',
    Us: '',
  },
  unknownError: {
    De: 'Ein unbekannter Fehler ist aufgetreten',
    En: 'An unknown error has occurred',
    Us: 'An unknown error has occurred',
  },
  userBlocked: {
    De:
      'Sie müssen erst noch vom Sorpetaler-Team für den Konfigurator freigeschaltet werden.',
    En:
      'You must first be activated by the Sorpetaler team for the configurator.',
    Us:
      'You must first be activated by the Sorpetaler team for the configurator.',
  },
  production: {
    De: 'Produktion',
    En: 'Live',
    Us: 'Live',
  },
  testing: {
    De: 'Entwicklung',
    En: 'Staging',
    Us: 'Staging',
  },
  stagingLoginHint: {
    De: 'Testumgebung – Staging-Login für den Fensterkonfigurator',
    En: 'Test environment – staging login for the window configurator',
    Us: 'Test environment – staging login for the window configurator',
  },
  pin: {
    De: 'PIN',
    En: 'PIN',
    Us: 'PIN',
  },
  pinValidationForm1: {
    De: 'VALIDIERUNG',
    En: 'Validation',
    Us: 'Validation',
  },
  pinValidationForm2: {
    De: 'PIN',
    En: 'PIN',
    Us: 'PIN',
  },
  forgotPasswordForm1: {
    De: 'PASSWORT',
    En: 'RESET',
    Us: 'RESET',
  },
  forgotPasswordForm2: {
    De: 'ZURÜCKSETZEN',
    En: 'PASSWORD',
    Us: 'PASSWORD',
  },
  validatePin: {
    De: 'Validieren des PIN',
    En: 'Validate your PIN',
    Us: 'Validate your PIN',
  },
  unknownFormError: {
    De:
      'Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Daten und versuchen Sie es erneut',
    En: 'An error occurred. Please check your data and try again',
    Us: 'An error occurred. Please check your data and try again',
  },
  registerCustomer1: {
    De: 'Registrierung',
    En: 'Registration',
    Us: 'Registration',
  },
  registerCustomer2: {
    De: 'Partnerkonto',
    En: 'Partner account',
    Us: 'Partner account',
  },
  registerCustomerAccount: {
    De: 'Registrieren der Partnerkonto',
    En: 'Register Partner Account',
    Us: 'Register Partner Account',
  },
  registrationInfoMessage: {
    De:
      'Wichtiger Hinweis: Der Sorpetaler-Fensterkonfigurator ist nur ' +
      'für unsere Partnerbetriebe (Fachhandelspartner wie Schreiner, Bauelementehändler usw.) nutzbar.',
    En:
      'Important note: The Sorpetaler window configurator is only' +
      'for our partner companies (specialist dealers such as carpenters, building component dealers, etc.).',
    Us:
      'Important note: The Sorpetaler window configurator is only' +
      'for our partner companies (specialist dealers such as carpenters, building component dealers, etc.).',
  },
  firstName: {
    De: 'Vorname',
    En: 'First name',
    Us: 'First name',
  },
  validFirstNameMessage: {
    De: 'Bitte geben Sie Ihren Vornamen ein',
    En: 'Please enter your first name',
    Us: 'Please enter your first name',
  },
  validLastNameMessage: {
    De: 'Bitte geben Sie Ihren Nachnamen ein',
    En: 'Please enter your last name',
    Us: 'Please enter your last name',
  },
  lastName: {
    De: 'Nachname',
    En: 'Last name',
    Us: 'Last name',
  },
  organization: {
    De: 'Organisation',
    En: 'Organization',
    Us: 'Organization',
  },
  validOrganizationMessage: {
    De: 'Bitte geben Sie Ihre Organisation ein',
    En: 'Please enter your organization name',
    Us: 'Please enter your organization name',
  },
  validPinEmailMessage: {
    De: 'Bitte geben Sie Ihre PIN ein, die Sie per E-Mail erhalten haben',
    En: 'Please enter the PIN that you have received by Email',
    Us: 'Please enter the PIN that you have received by Email',
  },
  validateRegPin: {
    De: 'Registrieren der Registrierung PIN',
    En: 'Register the Registration PIN',
    Us: 'Register the Registration PIN',
  },
  userExists: {
    De: 'Ein Benutzer mit dieser E-Mail-Adresse existiert bereits',
    En: 'A user with this email address already exists',
    Us: 'A user with this email address already exists',
  },
  resetPassword: {
    De: 'Passwort zurücksetzen',
    En: 'Reset Password',
    Us: 'Reset Password',
  },
  frontDoorStepsTitle: {
    De: 'In 3 Schritten zur neuen Haustür',
    En: 'In 3 steps to the new front door',
    Us: 'In 3 steps to the new front door',
  },
  in3Steps: {
    De: 'IN 3 SCHRITTEN',
    En: 'IN 3 STEPS',
    Us: 'IN 3 STEPS',
  },
  toThe: {
    De: 'ZUR',
    En: 'TO THE',
    Us: 'TO THE',
  },
  newFrontDoor: {
    De: 'NEUEN HAUSTÜR',
    En: 'NEW FRONT DOOR',
    Us: 'NEW FRONT DOOR',
  },
  constructionProjectQuestion: {
    De: 'Welches Bauvorhaben planen Sie?',
    En: 'Which construction project are you planning?',
    Us: 'Which construction project are you planning?',
  },
  selectOption: {
    De: 'Wählen Sie eine Option',
    En: 'Select an Option',
    Us: 'Select an Option',
  },
  oldBuilding: {
    De: 'Altbau',
    En: 'Old building',
    Us: 'Old building',
  },
  newBuilding: {
    De: 'Neubau',
    En: 'New building',
    Us: 'New building',
  },
  multipleSelectionPossible: {
    De: 'Mehrfachauswahl möglich',
    En: 'Multiple selection possible',
    Us: 'Multiple selection possible',
  },
  doorDesignQuestion: {
    De: 'Welches Türdesign gefällt Ihnen?',
    En: 'Which door design do you like?',
    Us: 'Which door design do you like?',
  },
  contactFormTitle: {
    De: 'Formular zur Kontaktaufnahme',
    En: 'Contact Form',
    Us: 'Contact Form',
  },
  yourSelection: {
    De: 'Ihre Auswahl',
    En: 'Your Selection',
    Us: 'Your Selection',
  },
  doorType: {
    De: 'Türart',
    En: 'Door type',
    Us: 'Door type',
  },
  design: {
    De: 'Design',
    En: 'Design',
    Us: 'Design',
  },
  whoReceivesOffer: {
    De: 'Wer erhält das unverbindliche Angebot?',
    En: 'Who receives the non-binding offer?',
    Us: 'Who receives the non-binding offer?',
  },
  projectLocationQuestion: {
    De: 'Wo befindet sich Ihr Bauvorhaben?',
    En: 'Where is your construction project located?',
    Us: 'Where is your construction project located?',
  },
  requestGuidePrices: {
    De: 'Jetzt Richtpreise anfragen',
    En: 'Request guide prices now',
    Us: 'Request guide prices now',
  },
  sending: {
    De: 'Wird gesendet...',
    En: 'Sending...',
    Us: 'Sending...',
  },
  back: {
    De: 'Zurück',
    En: 'Back',
    Us: 'Back',
  },
  next: {
    De: 'Weiter',
    En: 'Next',
    Us: 'Next',
  },
  start: {
    De: 'Starten',
    En: 'Start',
    Us: 'Start',
  },
  noDoorDesignsFound: {
    De: 'Keine Türdesigns gefunden.',
    En: 'No door designs found.',
    Us: 'No door designs found.',
  },
  // Widget error messages
  widgetSuccess: {
    De: 'Erfolg',
    En: 'Success',
    Us: 'Success',
  },
  widgetInvalidRequest: {
    De: 'Ungültige Anfrage',
    En: 'Invalid request',
    Us: 'Invalid request',
  },
  widgetDatabaseError: {
    De: 'Datenbankfehler',
    En: 'Database error',
    Us: 'Database error',
  },
  widgetPersonFieldMissing: {
    De: 'Personenfeld fehlt',
    En: 'Person field missing',
    Us: 'Person field missing',
  },
  widgetAddressFieldMissing: {
    De: 'Adressfeld fehlt',
    En: 'Address field missing',
    Us: 'Address field missing',
  },
  widgetEmailIncorrect: {
    De: 'E-Mail-Adresse ist ungültig',
    En: 'Email incorrect',
    Us: 'Email incorrect',
  },
  widgetEmailAlreadyUsed: {
    De: 'Diese E-Mail-Adresse wurde bereits für eine Kataloganfrage verwendet.',
    En: 'This email address has already been used for a catalogue request.',
    Us: 'This email address has already been used for a catalogue request.',
  },
  widgetPostalCodeMissing: {
    De: 'Postleitzahl fehlt',
    En: 'Postal code missing',
    Us: 'Postal code missing',
  },
  widgetTokenInvalid: {
    De: 'Token ungültig',
    En: 'Token invalid',
    Us: 'Token invalid',
  },
};
